var _path, _path2, _path3, _path4, _rect, _path5, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,93C16.607,93,11,87.393,11,80.5v-57C11,16.607,16.607,11,23.5,11h57C87.393,11,93,16.607,93,23.5v57 C93,87.393,87.393,93,80.5,93H23.5z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M21.5,91C14.607,91,9,85.393,9,78.5v-57C9,14.607,14.607,9,21.5,9h57C85.393,9,91,14.607,91,21.5v57 C91,85.393,85.393,91,78.5,91H21.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#70bfff",
    d: "M15.5,78.5v-57c0-3.314,2.686-6,6-6h57c3.314,0,6,2.686,6,6v57c0,3.314-2.686,6-6,6h-57 C18.186,84.5,15.5,81.814,15.5,78.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#40396e",
    d: "M78.5,86h-57c-4.136,0-7.5-3.364-7.5-7.5v-57c0-4.136,3.364-7.5,7.5-7.5h57 c4.136,0,7.5,3.364,7.5,7.5v57C86,82.636,82.636,86,78.5,86z M21.5,17c-2.481,0-4.5,2.019-4.5,4.5v57c0,2.481,2.019,4.5,4.5,4.5h57 c2.481,0,4.5-2.019,4.5-4.5v-57c0-2.481-2.019-4.5-4.5-4.5H21.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 30,
    x: 29,
    y: 41,
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M33.484,38h-0.049c-2.59,0-4.265-1.93-4.265-4.341c0-2.463,1.727-4.338,4.364-4.338 c2.64,0,4.267,1.875,4.315,4.338C37.849,36.068,36.174,38,33.484,38z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M70.99,71h-8.729V54.752c0-3.837-2.139-6.456-5.573-6.456c-2.62,0-4.038,1.767-4.726,3.474 c-0.251,0.611-0.176,2.301-0.176,3.155V71h-8.729V40.958h8.729v4.567c1.259-1.948,3.23-4.567,8.272-4.567 c6.247,0,10.931,3.928,10.931,12.699L70.99,71L70.99,71z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.71e1e63db4e3dc6b6da5c03afa324e06.svg";
export { ForwardRef as ReactComponent };